import React, { useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import { IconContext } from "react-icons";
import { MdLock, MdShare, MdContentCopy, MdCheck, MdEmail, MdSms } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

const CoursePackBox = ({ pack, onOpenModal }) => {
  const courses = pack.openQulRegs_pack || [];
  const [copied, setCopied] = useState(false);
  const [shareMenuOpen, setShareMenuOpen] = useState(false);

  const getShareUrl = () => `https://www.ismbonline.org/registrationTrainingDays?pId=${pack?.id_pack}`;
  const getShareText = () => pack?.name_pack || 'מארז';

  const handleShareToggle = (e) => { e.stopPropagation(); setShareMenuOpen(prev => !prev); };

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  };

  const handleCopyLink = (e) => {
    e.stopPropagation();
    const url = getShareUrl();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).catch(() => fallbackCopy(url));
    } else {
      fallbackCopy(url);
    }
    setCopied(true);
    setTimeout(() => { setCopied(false); setShareMenuOpen(false); }, 2000);
  };

  const handleWhatsApp = (e) => {
    e.stopPropagation();
    const text = encodeURIComponent(`${getShareText()}\n${getShareUrl()}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
    setShareMenuOpen(false);
  };

  const handleEmail = (e) => {
    e.stopPropagation();
    const subject = encodeURIComponent(getShareText());
    const body = encodeURIComponent(`${getShareText()}\n${getShareUrl()}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
    setShareMenuOpen(false);
  };

  const handleSMS = (e) => {
    e.stopPropagation();
    const body = encodeURIComponent(`${getShareText()}\n${getShareUrl()}`);
    window.location.href = `sms:?body=${body}`;
    setShareMenuOpen(false);
  };

  // מציאת התאריך ההתחלתי המוקדם ביותר
  const startDates = courses.map(c => new Date(c.mySelfQualificationDto?.startDate));
  const earliestStartDate = new Date(Math.min(...startDates));

  // חישוב עלות כוללת
  const totalPrice = courses.reduce((sum, course) => sum + (course.product?.price || 0), 0);

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("he-IL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

  return (
    // <div className="text-right flex flex-col border rounded-md m-2 p-2 bg-white shadow-sm" style={{ direction: "rtl" }}>
    <div className="text-right  flex flex-col relative border rounded-md m-2 p-1" style={{ direction: "rtl" }}>
      {/* <div className="text-base font-bold underline mb-2 text-green-800">פרטי מארז</div> */}
            {!pack?.allow && (
                                        <div className="absolute inset-0 bg-gray-200/60 backdrop-blur-[1px] flex items-center justify-center rounded-lg">
                                          <MdLock className="text-gray-600" size={40} />
                                        </div>
                                      )}
      <div className="flex items-center justify-between mb-1">
        <div className="text-base font-bold underline">פרטי מארז</div>
        <div className="relative">
          <button
            onClick={handleShareToggle}
            className='bg-[#1e8e2b] hover:bg-[#1a7925] rounded-lg px-2.5 py-1 transition-colors flex items-center gap-1.5'
            title='שתף'
          >
            <MdShare className='text-white' size={20} />
            <span className='text-white text-xs font-medium'>שתף</span>
          </button>
          {shareMenuOpen && (
            <>
              <div className='fixed inset-0 z-10' onClick={(e) => { e.stopPropagation(); setShareMenuOpen(false); }} />
              <div className='absolute top-8 left-0 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-[140px] z-30' style={{ direction: 'rtl' }}>
                <button onClick={handleWhatsApp} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                  <FaWhatsapp className='text-green-500' size={16} />
                  <span>וואטסאפ</span>
                </button>
                <button onClick={handleEmail} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                  <MdEmail className='text-blue-500' size={16} />
                  <span>מייל</span>
                </button>
                <button onClick={handleSMS} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                  <MdSms className='text-purple-500' size={16} />
                  <span>SMS</span>
                </button>
                <button onClick={handleCopyLink} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                  {copied ? <MdCheck className='text-green-600' size={16} /> : <MdContentCopy className='text-gray-600' size={16} />}
                  <span>{copied ? 'הועתק!' : 'העתק קישור'}</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* שמות ימי הכשירות */}
      <div className="mb-3">
        <span className="font-bold text-sm underline">ימי כשירות במארז:</span>
        <ul className="list-disc pr-5 mt-1 text-sm text-gray-700">
          {courses.map((course, idx) => (
            <li key={idx}>
              {course?.mySelfQualificationDto?.name || "ללא שם"}
            </li>
          ))}
        </ul>
      </div>

      {/* פרטים כלליים */}
      <div className="grid grid-cols-2 text-sm gap-4">
        <div className="flex items-center">
          <span className="ml-2 font-bold underline">תאריך התחלה:</span>
          <span>{formatDate(earliestStartDate)}</span>
        </div>

        <div className="flex items-center">
          <span className="ml-2 font-bold underline">עלות כוללת:</span>
          <span>{totalPrice.toLocaleString()} ₪</span>
        </div>
      </div>
  <IconContext.Provider value={{ size:"29px", className:"ml-2" }}>
            <button className='bg-[#1e8e2b] rounded-md text-white p-2 w-fit flex self-end items-center text-sm font-medium' onClick={()=>{pack?.allow && onOpenModal()}}> <BsPlusCircle/> להרשמה ופרטים נוספים</button>
            </IconContext.Provider>
      {/* כפתור
      <IconContext.Provider value={{ size: "26px", className: "ml-2" }}>
        <button
          className="bg-[#1e8e2b] rounded-md text-white px-4 py-2 mt-4 w-fit flex self-end items-center text-sm font-medium"
          onClick={onOpenModal}
        >
          <BsPlusCircle /> להרשמה ופרטים נוספים
        </button>
      </IconContext.Provider> */}
    </div>
  );
};

export default CoursePackBox;